import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  ILegalTexts,
  WhitelabelImage,
  WhitelabelImageAltTag,
  WhitelabelImageType,
} from '@resident-nx/shared';
import { RouterLink } from '@angular/router';
import { footerNavItems } from '../../../../models';
import { WhitelabelImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  selector: 'rs-web-consent-privacy',
  standalone: true,
  templateUrl: './consent-privacy.component.html',
  styleUrls: ['../shared/consent-page-base.scss', './consent-privacy.component.scss'],
  imports: [ImmomioButtonComponent, TranslateModule, WhitelabelImageWebComponent, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsentPrivacyWebComponent {
  readonly WhitelabelImage = WhitelabelImage;
  readonly WhitelabelImageAltTag = WhitelabelImageAltTag;
  readonly WhitelabelImageType = WhitelabelImageType;
  readonly legalTexts = input.required<ILegalTexts>();
  readonly isLoading = input.required<boolean>();
  readonly acceptConsent = output<{ legalTextId: string; consentGiven: boolean }>();
  readonly privacyFooterItem = footerNavItems.find(item => item.link === 'privacy');
}
